/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function DuplicateIcon({ className, size = 'small' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 20 20" },
        jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M14 5v12.5a.5.5 0 01-.5.5H3v-1h10V5h1zm-2.997-5c.544 0 .997.448.997 1v14a1 1 0 01-1.002 1H1.002A1.005 1.005 0 010 15V4.04l.018-.019V4h.02L3.5.505V.5h.005L4 0zM4.5 1v3.5A.5.5 0 014 5H1l.002 10H11V1L4.5 1zm-1 .926L1.445 4H3.5V1.926z" })));
}
//# sourceMappingURL=DuplicateIcon.js.map